export default {
  text: '',
  filter: false
}
